/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiCursorAMoveIcon16Light } from './UiCursorAMoveIcon16Light';
import { UiCursorAMoveIcon16Regular } from './UiCursorAMoveIcon16Regular';
import { UiCursorAMoveIcon16Solid } from './UiCursorAMoveIcon16Solid';
import { UiCursorAMoveIcon20Light } from './UiCursorAMoveIcon20Light';
import { UiCursorAMoveIcon20Regular } from './UiCursorAMoveIcon20Regular';
import { UiCursorAMoveIcon20Solid } from './UiCursorAMoveIcon20Solid';
import { UiCursorAMoveIcon24Regular } from './UiCursorAMoveIcon24Regular';
import { UiCursorAMoveIcon24Solid } from './UiCursorAMoveIcon24Solid';
import { UiCursorAMoveIcon32Regular } from './UiCursorAMoveIcon32Regular';
import { UiCursorAMoveIcon64Regular } from './UiCursorAMoveIcon64Regular';
var sizes = {
    16: {
        light: UiCursorAMoveIcon16Light,
        regular: UiCursorAMoveIcon16Regular,
        solid: UiCursorAMoveIcon16Solid,
    },
    20: {
        light: UiCursorAMoveIcon20Light,
        regular: UiCursorAMoveIcon20Regular,
        solid: UiCursorAMoveIcon20Solid,
    },
    24: {
        regular: UiCursorAMoveIcon24Regular,
        solid: UiCursorAMoveIcon24Solid,
    },
    32: {
        regular: UiCursorAMoveIcon32Regular,
    },
    64: {
        regular: UiCursorAMoveIcon64Regular,
    },
};
export var UiCursorAMoveIcon = forwardRef('UiCursorAMoveIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
